import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import InputMultiline from '../../components/InputMultiline';
import RadioButton from '../../components/RadioButton';
import Select from '../../components/Select';
import FormButtons from '../../components/FormButtons';
import useFields from '../../hooks/useFields';
import { formatValuesLoad } from '../index/values';

const Description = styled.div`
  align-items: center;
  font-weight: 700;
  font-size: 14px;
  color: var(--text-text02);
  margin-bottom: 24px;
`;

interface BseHealthProps {
  idRequest: number;
  save: (
    formName: string,
    fields: any,
    isComplete: boolean,
    save: boolean
  ) => void;
  next: () => void;
}

const BseHealth = (props: BseHealthProps) => {
  const { idRequest, next, save } = props;
  const [validateForm, setValidateForm] = useState(0);
  const formBse = useSelector((state: any) => state.getFormBse);

  const { formHealth } = formatValuesLoad(formBse?.data);
  const {
    fields,
    setFieldValue,
    setFieldError,
    formIsValid,
    formIsComplete,
    formIsEmpty
  } = useFields(formHealth);
  const { healthDiagnosis, healthDiagnosisDetail, healthPertenencia } = fields;

  const validateCaseIsIncomplete = (fieldsHealt: any) => {
    if (fieldsHealt?.healthDiagnosis === 'No') {
      if (fieldsHealt?.healthPertenencia !== '') {
        fields.healthDiagnosisDetail = ' ';
        return true;
      }
    }
    if (fieldsHealt?.healthDiagnosis === 'Yes') {
      if (fieldsHealt?.healthDiagnosisDetail === ' ') {
        fields.healthDiagnosisDetail = '';
        return false;
      }
      if (
        fieldsHealt?.healthDiagnosisDetail !== '' &&
        fieldsHealt?.healthPertenencia !== ''
      ) {
        return true;
      }
    }
    return false;
  };

  const saveForm = () => {
    setValidateForm(validateForm + 1);
    save('health', fields, validateCaseIsIncomplete(fields), true);
  };

  React.useEffect(() => {
    if (idRequest > 0 && !formIsEmpty) {
      save('health', fields, formIsComplete, false);
    }
  }, [idRequest, formIsEmpty]);
  if (!formBse?.data) return null;

  return (
    <div style={{ padding: '16px 24px' }} data-testid="cmp-form-salud">
      <Description>
        Cuéntanos el estado de salud tuyo y de tu familiar.
      </Description>
      <RadioButton
        question="¿Cuenta con algún diagnóstico que genera tratamiento de
        salud?"
        firstLabel="Sí"
        firstValue="Yes"
        secondLabel="No"
        secondValue="No"
        value={healthDiagnosis}
        groupName="healthDiagnosis"
        setFieldError={setFieldError}
        setFieldValue={setFieldValue}
        validateOnStart={idRequest ? idRequest > 0 && !formIsEmpty : false}
        validateForm={validateForm}
        isRequired
        // {...getProps()}
      >
        <InputMultiline
          nameLabel=""
          value={healthDiagnosisDetail}
          name="healthDiagnosisDetail"
          maxLength={100}
          showCount
          setFieldError={setFieldError}
          setFieldValue={setFieldValue}
          validateOnStart={
            healthDiagnosisDetail === '' && healthDiagnosis === 'Yes'
          }
          validateForm={!idRequest ? 0 : 1}
          isRequired={healthDiagnosis === 'Yes'}
          // {...getProps()}
        />
        <div />
      </RadioButton>
      <div style={{ margin: '0 0 9px 0' }} />

      <div style={{ display: 'flex' }}>
        <Description>Salud familiar</Description>
      </div>
      <Select
        nameLabel="Estado de salud"
        value={healthPertenencia}
        name="healthPertenencia"
        optionsList={formBse?.data?.[78]?.dropDownList}
        placeholder="Selecciona la pertenencia"
        setFieldValue={setFieldValue}
        validateOnStart={idRequest ? idRequest > 0 && !formIsEmpty : false}
        validateForm={validateForm}
        top
      />
      {/* <Select
        nameLabel="Sobre COVID-19"
        value={healthEstado}
        name="healthEstado"
        optionsList={formBse?.data && formBse.data[69].dropDownList}
        placeholder="Selecciona el estado de salud"
        setFieldValue={setFieldValue}
        validateOnStart={idRequest ? idRequest > 0 && !formIsEmpty : false}
        validateForm={validateForm}
        top
      />
      <Select
        nameLabel=""
        value={}
        name=""
        optionsList={formBse?.data && formBse.data[70].dropDownList}
        placeholder="Selecciona el estado laboral"
        setFieldValue={setFieldValue}
        validateOnStart={idRequest ? idRequest > 0 && !formIsEmpty : false}
        validateForm={validateForm}
        top
      /> */}

      <FormButtons
        handlerSend={saveForm}
        handlerNext={next}
        formIsValid={formIsValid}
      />
    </div>
  );
};

export default BseHealth;
